import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { setCommonAmmControlloListeners } from '../../listeners/amm-controllo-common.form-listeners';
import { my_CkNormeListenerHelper } from '../../listeners/amm-controllo-norme.listeners';
import { my_AllRevisoriControlloContabileListenerHelper } from '../../listeners/amm-controllo-collegio-sindacale.listeners';
import { my_AllLiquidatoriCaricaListenerHelper } from '../../listeners/amm-controllo-liquidatori.listeners';
import { my_AllLiquidatoriComuneCH } from '../../common/helpers/norme-comune-provincia.helper';
import { my_SpdConsGestComuneProvinciaCH, my_SpdConsSorvComuneProvincieCH } from '../../common/helpers/norme-spa-helpers.helper';
import { my_SpdCoop9SociListenerHelper } from '../../common/helpers/coop-soci-listener.helper';
import { setNormeSpaDualisticoConsiglioListeners } from './norme-spa-dualistico-spd-consigli.listeners';

export class NormeSpaDualisticoFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setNormeSpaDualisticoConsiglioListeners(this.form, this.store);

        setCommonAmmControlloListeners(this.form, this.store);
        my_CkNormeListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaDualistico);
        my_AllLiquidatoriCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaDualistico);
        my_AllRevisoriControlloContabileListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaDualistico);
        my_AllLiquidatoriComuneCH(this.form, this.store);

        my_SpdConsSorvComuneProvincieCH(this.form, this.store);
        my_SpdConsGestComuneProvinciaCH(this.form, this.store);

        my_SpdCoop9SociListenerHelper(this.form, this.store);
    }
}
